import { render, staticRenderFns } from "./AddCategoryPrinciple.vue?vue&type=template&id=8b9cf0d2&scoped=true&"
import script from "./AddCategoryPrinciple.vue?vue&type=script&lang=js&"
export * from "./AddCategoryPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryPrinciple.vue?vue&type=style&index=0&id=8b9cf0d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9cf0d2",
  null
  
)

export default component.exports